import {apolloClient} from "seu-frontend/graphql/apollo";
import LIST_CATEGORIES from "./listCategories.gql";

const listCategories = ({filter, pagination, search, lang} = {}, {includeTranslations} = {includeTranslations:false}) => {
  return apolloClient.query({
    query: LIST_CATEGORIES,
    variables: {
      input: {
        filter,
        pagination,
        search
      },
      lang,
      includeTranslations
    },
    fetchPolicy: 'no-cache'
  }).then(({data: {categories}}) => categories)
}

export {
  listCategories
}
